
























































import Vue from 'vue';
import layout from '@/libs/layout/school/consuption';
import { Prop, Component } from 'vue-property-decorator';
import {
  TConsuptionPage,
  TConsuptionSearch,
  TReturnDialogForm
} from '@/types/views/school.d.ts';
import { TLayout } from '@/types/utils';
@Component({
  components: {
    Dialog: () => import('./dialog.vue')
  }
})
export default class List extends Vue {
  @Prop({
    type: Object,
    default() {
      return {
        totalPage: 1,
        currentPage: 1,
        pageSize: 20,
        totalQty: 1,
        list: []
      };
    }
  })
  page!: TConsuptionPage;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  private layout: TLayout = layout;
  private applyInfo: Object = {};

  private indexMethod(idx: number) {
    const { currentPage, pageSize } = this.page;
    return ((currentPage as number) - 1) * (pageSize as number) + idx + 1;
  }
  private handlePage(page: number) {
    this.handleOptions({ currentPage: page });
    this.getData();
  }
  private handleSize(pageSize: number) {
    this.handleOptions({ pageSize });
    this.getData();
  }
  private showApplyRefundDialog(vo: any): void {
    this.applyInfo = { ...vo };
    (this.$refs.applyRefundDialog as any).dialogVisible = true;
  }
}
